import React from 'react';
import { PaymentIssueRow } from '../callCenterPaymentIssuesTypes';
import { PriorityBadge, StatusBadge, ViewButton, IssueCard } from '../../shared';
import sharedStyles from '../../shared/IssueTable.module.css';
import styles from './PaymentIssuesTable.module.css';

interface PaymentIssuesTableProps {
  rows: PaymentIssueRow[];
  onView?: (id: string) => void;
}

export const PaymentIssuesTable: React.FC<PaymentIssuesTableProps> = ({ rows, onView }) => {
  return (
    <IssueCard title="Payment Issues">
      <div className={sharedStyles.tableWrap}>
        <table className={sharedStyles.table}>
          <thead>
            <tr>
              <th>TICKET ID</th>
              <th>INVOICE #</th>
              <th>AMOUNT DISPUTED</th>
              <th>PAYMENT TYPE</th>
              <th>PRIORITY</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={sharedStyles.ticketId}>{row.ticketId}</td>
                <td>{row.invoiceNumber}</td>
                <td className={sharedStyles.bold}>{row.amountDisputed}</td>
                <td className={`${styles.paymentType} ${styles[`pt_${row.paymentType.toLowerCase()}`]}`}>
                  {row.paymentType}
                </td>
                <td>
                  <PriorityBadge priority={row.priority} />
                </td>
                <td>
                  <StatusBadge status={row.status} />
                </td>
                <td>
                  <ViewButton onClick={() => onView?.(row.id)} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </IssueCard>
  );
};
